import React, { useState } from "react";

const AuthContext = React.createContext({
  user: {
    username: "",
    facilities: [],
    members: [],
    token: "",
    isAnyAdmin: false
  },
  setUser: () => {},
});

export const AuthProvider = (props) => {
  const [user, storeUser] = useState({ username: "", facilities: [], members: [], token: "", isAnyAdmin: false});
  const setUser = (obj) => {
    if (obj.facilities !== undefined) {
      let isAnyAdmin = false;
      obj.facilities.some((facility) => {
        if (facility.is_admin) {
          isAnyAdmin = true;
          return true;
        }
        return false;
      });
      obj.isAnyAdmin = isAnyAdmin;
    }
    storeUser(obj);
  }

  return (
    <AuthContext.Provider value={[user, setUser]}>
      {props.children}
    </AuthContext.Provider>
  );
};

export const AuthConsumer = AuthContext.Consumer;

export default AuthContext;
